import { Alert } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { TbBriefcase } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import { useStartShiftMutation } from "@/requests/daily-status.queries";
import { useShiftShowStartShiftConfirmation } from "@/stores/use-shift";

function StartShift({
    handleClose,
    shiftExists,
}: {
    shiftExists: boolean;
    handleClose: (val?: boolean, shift?: boolean) => void;
}) {
    const { t } = useTranslation();
    const showStartShiftConfirmation = useShiftShowStartShiftConfirmation();

    const { mutateAsync, isPending } = useStartShiftMutation();
    const isRequestingLocationRef = useRef<boolean>(false);

    const positionSuccessCb = async ({ coords }: GeolocationPosition) => {
        // Allow further attempts after this callback resolves
        isRequestingLocationRef.current = false;
        if (isPending) return;
        try {
            const latitude = coords.latitude;
            const longitude = coords.longitude;
            if (!latitude || !longitude) {
                enqueueSnackbar(t(`GeolocationPositionError.1`), { variant: "error" });
                return;
            }
            await mutateAsync({ latitude, longitude });
            enqueueSnackbar("Mesainiz başarılı şekilde başlatıldı.", { variant: "success" });

            handleClose(false, true);
        } catch (err) {
            console.error("positionSuccessCb error:", err);
        }
    };

    const positionErrorCb = ({ code }: { code?: number; message: string }) => {
        // Re-enable confirm on error so user can retry
        isRequestingLocationRef.current = false;
        t(`GeolocationPositionError.${code ? code.toString() : "1"}`);
        enqueueSnackbar(t(`GeolocationPositionError.${code ? code.toString() : "1"}`), { variant: "error" });
    };

    const handleConfirm = async () => {
        if (isPending || isRequestingLocationRef.current) return;
        if (!("navigator" in window) || !("geolocation" in navigator)) {
            enqueueSnackbar(
                "Kullandığınız tarayıcı konum almayı desteklemiyor.Lütfen farklı bir tarayıcıdan tekrar deneyiniz.",
                { variant: "info" }
            );
            return;
        }
        // Lock to prevent multiple concurrent geolocation requests
        isRequestingLocationRef.current = true;
        navigator.geolocation.getCurrentPosition(positionSuccessCb, positionErrorCb);
    };

    return (
        <CommonAlert
            open={showStartShiftConfirmation}
            loading={isPending || isRequestingLocationRef.current}
            description="confirmations.startShift"
            color="primary"
            onClose={() => {
                handleClose(false);
            }}
            handleConfirm={handleConfirm}
            html
            icon={TbBriefcase}
        >
            {shiftExists && (
                <Alert icon={false} className="mt-2" severity="error">
                    {t("infos.holidayWillRemoved")}
                </Alert>
            )}
        </CommonAlert>
    );
}

export default StartShift;
